<!--  ********************** Contenido de la barra superior **********************  -->
<mat-toolbar class="topnav">
  <mat-toolbar-row>
    <!--                  Logo               -->
    <img width="120" style="margin-top: 2px; margin-bottom: 2px;" src="../../assets/images/ralarsa-logo-claro.png"/>

    <!--             Desplegable de usuario superior                  -->
    <div class="toolbar-section start" style="background-color: #e7f4e4 !important;" *ngIf="checkSuperUser()">
      <mat-form-field appearance="fill" id="selectTaller" >
        <mat-label>Taller Actual</mat-label>
        <mat-select panelClass="custom-select-panel" [(ngModel)]="tallerActual">
          <mat-option *ngFor="let taller of talleresSeleccionables" [value]="taller[0]" style="color: #b4f4a6 !important;" (click)="buscarPeticion()">
            {{ taller[1] }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!--             Sección del final(usuario)                  -->
    <div class="toolbar-section end">
      <div class="icon-container">
        <button id="user-content" (click)="logout()" (mouseenter)="onHover()" (mouseleave)="onLeave()">
          <span id="txt-toolbar">{{ buttonText }}</span>
          <img [src]="buttonIcon" width = 40 style="margin-bottom: 2px;" />
        </button>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<!--  ********************** Contenido del cuerpo **********************  -->
<body class="body">
  <div class="tab fixed-tabs">
    <button class="tablinks" [class.active]="activeTab === 'tab_gestion'" (click)="openTab('tab_gestion')">GESTIÓN PETICIÓN</button>
    <button class="tablinks" [class.active]="activeTab === 'tab_consulta'" (click)="openTab('tab_consulta')">CONSULTA DEVOLUCIONES</button>
  </div>
  <div #overlayContainer></div>

  <!-- Contenido de la pestaña "Contenido" -->
  <div #tab_gestion class="tabcontent">
    <div class="section-form">
      <div class="container-filtros">
        <div class="input-wrapper-range">
          <div class="icon-wrapper">
            <img src="../../assets/icons/icon_fecha.svg" class="input-icon">
          </div>
          <mat-form-field  class="form-fecha" appearance="fill">
            <mat-label>Fecha petición</mat-label>
            <mat-date-range-input [rangePicker]="picker" [min]="minDate" (click)="picker.open()">
              <input matStartDate [(ngModel)]="this.fechaInicio">
              <input matEndDate [(ngModel)]="this.fechaFin">
            </mat-date-range-input>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="input-wrapper-range">
          <div class="icon-wrapper">
            <img src="../../assets/icons/icon_estimacion_entrega.svg" class="input-icon">
          </div>
          <mat-form-field  class="form-fecha" appearance="fill">
            <mat-label>Estimación entrega</mat-label>
            <mat-date-range-input [rangePicker]="pickerPrev" [min]="minDate" (click)="pickerPrev.open()">
              <input matStartDate [(ngModel)]="this.fechaPrevInicio">
              <input matEndDate [(ngModel)]="this.fechaPrevFin">
            </mat-date-range-input>
            <mat-date-range-picker #pickerPrev></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="input-wrapper">
          <div class="icon-wrapper">
            <img src="../../assets/icons/icon_peticion.svg" class="input-icon">
          </div>

          <input matInput placeholder="Petición" maxlength="10" [(ngModel)]="this.peticionPet">

        </div>
        <div class="input-wrapper">
          <div class="icon-wrapper">
            <img [src]="getSelectedImage()" class="input-icon">
          </div>
          <mat-form-field style="width: 86%">
            <mat-label>Estado petición</mat-label>
            <mat-select panelClass="extend-panel" [(value)]="selectedEstado">
              <mat-option>
                <div class="select-option">
                  <div class="icon">
                    <img src="../../assets/icons/speed/icon_estado_pet.svg" />
                  </div>
                  <span class="text"></span>
                </div>
              </mat-option>
              <mat-option *ngFor="let estado of estados" [value]="estado.value">
                <div class="select-option">
                  <div class="icon">
                    <img [src]="estado.img" />
                  </div>
                  <span class="text">{{ estado.label }}</span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
      </div>
      <div class="container-filtros" style=" margin-top: 10px !important;">
        <div class="input-wrapper">
          <div class="icon-wrapper">
            <img src="../../assets/icons/icon_categoria.svg" class="input-icon">
          </div>
          <mat-form-field style="width: 86%">
            <mat-label>Categoría</mat-label>
            <mat-select panelClass="custom-select-panel" [(value)]="selectedCat">
              <mat-option></mat-option>
              <mat-option *ngFor="let cat of arrayCategoria" [value]="cat">
                {{cat}}
              </mat-option>
            </mat-select>
          </mat-form-field>


        </div>

        <div class="input-wrapper">
          <div class="icon-wrapper">
            <img src="../../assets/icons/icon_matricula.svg" class="input-icon">
          </div>
          <input matInput placeholder="Matrícula" [(ngModel)]="this.matriculaPet" maxlength="10">
        </div>

        <div class="input-wrapper">
          <div class="icon-wrapper">
            <img src="../../assets/icons/icon_eurocode.svg" class="input-icon">
          </div>
          <input matInput placeholder="Eurocode" [(ngModel)]="this.eurocode" maxlength="25">
        </div>

        <div class="input-wrapper-button">
          <button *ngIf="checkLimpiar()" class="boton-def" style="width: 21.5%" (click)="limpiarFiltros()"><img src="../../assets/icons/speed/icon_limpiar.svg" style="width: 40px !important;height: 40px !important;"></button>
          <span *ngIf="checkLimpiar()" style="width: 2%; background-color: #e2ede7 !important;"></span>
          <button class="boton-prin" style="width: 100%" (click)="buscarPeticion()">Buscar</button>
        </div>
      </div>
      <div class="tablaGestion">
        <table class="tabla-art" mat-table [dataSource]="dataSource" multiTemplateDataRows>
          <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
            <!-- Columna flecha/arrow -->
            <ng-container *ngIf="column === 'arrow'">
              <th mat-header-cell *matHeaderCellDef>{{column}}</th>
              <td mat-cell *matCellDef="let element" (click)="toggleRow(element)">
                <button mat-icon-button class="arrow-btn">
                  <img
                    [src]="expandedElement === element ? 'assets/icons/flecha_expanded.svg' : 'assets/icons/flecha.svg'"
                    [alt]="expandedElement === element ? 'Collapse' : 'Expand'"
                    width="24"
                    height="24"
                  />
                </button>
              </td>
            </ng-container>

            <!-- Columna estado -->
            <ng-container *ngIf="column === 'estado'">
              <th mat-header-cell *matHeaderCellDef>{{column}}</th>
              <td mat-cell *matCellDef="let element" (click)="loadOverlay(element)">
                {{ traductorEstadosNuevosPet(element['estado']?.trim(), element['cdn']?.trim()) }}
              </td>
            </ng-container>

            <!-- Columna estimacion_entrega -->
            <ng-container *ngIf="column === 'estimacion_entrega'">
              <th mat-header-cell *matHeaderCellDef>{{column}}</th>
              <td mat-cell *matCellDef="let element" (click)="loadOverlay(element)">
                <ng-container *ngIf="element['estimacion_entrega'] && element['estimacion_entrega'].trim() !== '01-01-0001'">
                  {{ element['estimacion_entrega'] }}
                </ng-container>
                <ng-container *ngIf="!element['estimacion_entrega'] || element['estimacion_entrega'].trim() === '01-01-0001'">
                  Sin estimación
                </ng-container>
              </td>
            </ng-container>

            <!-- Columna max_fecha_entrega -->
            <ng-container *ngIf="column === 'max_fecha_entrega'">
              <th mat-header-cell *matHeaderCellDef>{{column}}</th>
              <td mat-cell *matCellDef="let element" (click)="loadOverlay(element)">
                <ng-container *ngIf="element['max_fecha_entrega'] && element['max_fecha_entrega'].trim() !== '01-01-0001'">
                  {{ element['max_fecha_entrega'] }}
                </ng-container>
                <ng-container *ngIf="!element['max_fecha_entrega'] || element['max_fecha_entrega'].trim() === '01-01-0001'">
                  Sin estimación
                </ng-container>
              </td>
            </ng-container>

            <!-- Columna gestión -->
            <ng-container *ngIf="column === 'gestion'">
              <th mat-header-cell *matHeaderCellDef>{{column}}</th>
              <td mat-cell *matCellDef="let element" style="width: 256px !important;">
                <div style="display: flex; flex-direction: row;">
                  <ng-container *ngFor="let gestion of traduccionGestion[element['gestion']?.trim()]">
                    <button
                      mat-button
                      [ngClass]="gestion[1]"
                      (click)="gestionarPeticion(element, gestion[1])"
                      class="gestionButtons"
                      *ngIf="condicionBotonPeticion(element)">
                      {{ gestion[0] }}
                    </button>
                  </ng-container>
                </div>
                <span *ngIf="element['gestion_final']?.trim() !== '' && element['gestion_final']?.trim() !== 'R'">
                  Gestión Pendiente
                </span>
              </td>
            </ng-container>

            <!-- Columnas dinámicas por defecto -->
            <ng-container>
              <th mat-header-cell *matHeaderCellDef>{{column}}</th>
              <td mat-cell *matCellDef="let element" (click)="loadOverlay(element)">
                {{ element[column] }}
              </td>
            </ng-container>
          </ng-container>

          <!-- Expanded Content Column -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
              <div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                <div class="element-description" style="width: 90%; display: block; margin: 0 auto;">
                  <table style="width: 100%;" class="tabla-expanded" *ngIf="detailData[element.id]?.length > 0 && !this.cargaSecundarios; else loading">
                    <thead>
                    <tr>
                      <!-- Renderiza las claves como encabezados de las columnas -->
                      <th *ngFor="let column of nombrePersonalizadoDetalle"
                          [ngStyle]="{ 'background-color': column === '' ? '#E2EDE7' : '#c7dbd0'}">
                        {{ column }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let row of detailData[element.id]">
                      <!-- Renderiza las celdas según displayedColumnsDetalle -->
                      <td *ngFor="let column of displayedColumnsDetalle"
                          [ngStyle]="{ 'background-color': column === 'peticion' ? '#c7dbd0' : '#d5e4dd',
                          'font-weight': column === 'peticion' ? 'bold' : 'normal', 'width': column === 'gestion' ? '256px' : 'auto'}"
                          (click)="column !== 'gestion' && loadOverlay(row)">
                        <!-- Condiciones para columnas personalizadas -->
                        <ng-container [ngSwitch]="column">
                          <!-- Contenido personalizado para 'gestion' -->
                          <ng-container *ngSwitchCase="'gestion'">
                            <div style="display: flex; flex-direction: row;">
                              <ng-container *ngFor="let gestion of traduccionGestion[row['gestion']?.trim()]">
                                <button
                                  mat-button
                                  [ngClass]="gestion[1]"
                                  (click)="gestionarPeticion(row, gestion[1])"
                                  class="gestionButtons"
                                  *ngIf="condicionBotonPeticion(element)">
                                  {{ gestion[0] }}
                                </button>
                              </ng-container>
                            </div>
                            <span
                              *ngIf="row['gestion_final']?.trim() !== ''
                              && row['gestion_final']?.trim() !== 'R'">
                                Gestión Pendiente
                            </span>
                          </ng-container>
                          <!-- Contenido personalizado para 'estado' -->
                          <ng-container *ngSwitchCase="'estado'">
                            {{ traductorEstadosNuevosPet(row['estado']?.trim(), row['cdn']?.trim()) }}
                          </ng-container>
                          <!-- Contenido personalizado para 'f_entrega' -->
                          <ng-container *ngSwitchCase="'f_entrega'">
                            <ng-container *ngIf="row['f_entrega'] && row['f_entrega'].trim() !== '01-01-0001'">
                              {{ row['f_entrega'] }}
                            </ng-container>
                            <ng-container *ngIf="!row['f_entrega'] || row['f_entrega'].trim() === '01-01-0001'">
                              Sin estimación
                            </ng-container>
                          </ng-container>
                          <!-- Contenido estándar para otras columnas -->
                          <ng-container *ngSwitchDefault>
                            {{ row[column] }}
                          </ng-container>
                        </ng-container>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <!-- Mensaje de "No hay datos" -->
                  <div *ngIf="(!detailData[element.id] || detailData[element.id]?.length === 0) && !this.cargaSecundarios" class="no-data-message">
                    No hay peticiones complementarias.
                  </div>

                  <!-- Barra de carga -->
                  <ng-template #loading>
                    <mat-progress-bar *ngIf="this.cargaSecundarios" mode="indeterminate"></mat-progress-bar>
                  </ng-template>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-row *matRowDef="let element; columns: displayedColumns;"
              class="element-row"
              [class.expanded-row]="expandedElement === element">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
        </table>
      </div>

      <mat-progress-bar *ngIf="mostrarCarga" mode="indeterminate"></mat-progress-bar>
      <mat-paginator class="paginador"
                     [length]="rowsPeticiones"
                     [pageSize]="30"
                     [showFirstLastButtons]="true"
                     [hidePageSize] = "true"
                     [disabled]="mostrarCarga"
                     #paginator
                     (page)="onPageChange($event, paginator)"
      ></mat-paginator>
    </div>
  </div>
  <div #tab_consulta class="tabcontent">
    <!-- Contenido de la pestaña "Devoluciones" -->
    <div class="section-form">
      <div class="container-filtros">
        <div class="input-wrapper">
          <div class="icon-wrapper">
            <img src="../../assets/icons/icon_fec_ini.svg" class="input-icon">
          </div>
          <input matInput placeholder="Fecha Inicio" [matDatepicker]="fInicio" [min]="minDate" (click)="fInicio.open()" [(ngModel)]="this.fechaInicioDev">
          <mat-datepicker #fInicio></mat-datepicker>
        </div>
        <div class="input-wrapper">
          <div class="icon-wrapper">
            <img src="../../assets/icons/icon_fec_fin.svg" class="input-icon">
          </div>
          <input matInput placeholder="Fecha Fin" [matDatepicker]="fFin" [min]="minDate" (click)="fFin.open()" [(ngModel)]="this.fechaFinDev">
          <mat-datepicker #fFin></mat-datepicker>
        </div>

        <div class="input-wrapper">
          <div class="icon-wrapper">
            <img src="../../assets/icons/icon_matricula.svg" class="input-icon">
          </div>
          <input matInput placeholder="Matrícula" [(ngModel)]="this.matriculaDev" maxlength="10">
        </div>

        <div class="input-wrapper">
          <div class="icon-wrapper">
            <img src="../../assets/icons/icon_peticion.svg" class="input-icon">
          </div>
          <input matInput placeholder="Petición" [(ngModel)]="this.peticionDev" maxlength="10">
        </div>

        <div class="input-wrapper" style="width: 250px;">
          <button class="boton-prin" style="width: 100%" (click)="buscarDevolucion()">Buscar</button>
        </div>
      </div>
      <div class="tablaGestion">
        <table class="tabla-art" mat-table [dataSource]="dataSourceDev">

          <ng-container *ngFor="let column of displayedColumnsDev" [matColumnDef]="column">

            <ng-container #estadoColumn *ngIf="column === 'estado'; else defaultColumn">
              <ng-container *matCellDef="let element">
                <td mat-cell (click)="loadOverlayDevolucion(element)">{{ this.traduccionEstado[element[column].trim()] }}</td>
              </ng-container>
            </ng-container>

            <ng-container #gestionolumn *ngIf="column === 'gestion_actual'; else defaultColumn">
              <ng-container *matCellDef="let element">
                <td mat-cell (click)="loadOverlayDevolucion(element)">{{ this.traduccionEstadoFinal[element[column]] }}</td>
              </ng-container>
            </ng-container>

            <ng-container #gestionolumn *ngIf="column === 'botonPdf'; else defaultColumn">
              <ng-container *matCellDef="let element">
                <td mat-cell >
                  <button
                      mat-button
                      (click)="descargarPDFAlbaran(element)"
                      class="gestionButtons receive-btn">
                    Descargar Albaran
                  </button>
                </td>
              </ng-container>
            </ng-container>

            <ng-template #defaultColumn>
              <ng-container *matCellDef="let element">
                <td mat-cell (click)="loadOverlayDevolucion(element)">{{ element[column] }}</td>
              </ng-container>
            </ng-template>
          </ng-container>



          <tr mat-row *matRowDef="let row; columns: displayedColumnsDev;" class="element-row"></tr>

        </table>
      </div>
      <mat-progress-bar *ngIf="mostrarCargaDev" mode="indeterminate"></mat-progress-bar>
      <mat-paginator class="paginador"
                     [length]="rowsDevoluciones"
                     [pageSize]="30"
                     [showFirstLastButtons]="true"
                     [hidePageSize] = "true"
                     [disabled]="mostrarCargaDev"
                     #paginatorDev
                     (page)="onPageChange($event, this.paginatorDev)"
      ></mat-paginator>
    </div>
  </div>
</body>
